import './config.css';

import { App as AntdApp, ConfigProvider } from 'antd';
import { createStyles } from 'antd-style';
import React, { type PropsWithChildren } from 'react';

const useTableStyle = () => {
  return createStyles(({ css }) => ({
    table: css({
      '.ant-table-container': {
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.07)',
        borderRadius: '12px',
        overflow: 'hidden',
      },
      '.ant-table': {
        borderRadius: '12px',
      },
    }),
  }))();
};

export const ConfigStylesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { styles } = useTableStyle();

  return (
    <ConfigProvider
      componentSize="large"
      table={{
        className: styles['table'],
      }}
      theme={{
        token: {
          fontFamily: 'Figtree',
          colorBgElevated: '#F6F8FA',
          colorPrimary: '#00B7D6',
          colorInfo: '#00B7D6',
          colorBgContainer: '#ffffff',
          colorBgLayout: '#EDF1F5',
          colorBgBase: '#EDF1F5',
          colorPrimaryBorder: '#89DDEC',
          colorBorderSecondary: '#E2E7EA',
          colorBorderBg: '#CFD4DA',
          colorText: '#272D39',
          colorTextSecondary: '#7C8498',
        },
        components: {
          Menu: {
            itemColor: '#272D39',
            itemSelectedColor: '#052636',
            itemSelectedBg: '#C4EEF5',
          },
          Drawer: {
            colorBgElevated: '#fff',
          },
          Modal: {
            colorBgElevated: '#fff',
          },
          Popover: {
            colorBgElevated: '#fff',
          },
          Table: {
            headerBg: '#fff',
            rowHoverBg: '#EDF1F5',
          },
          Tag: {
            colorBgElevated: '#F6F8FA',
          },
          Typography: {
            colorLink: '#1677ff',
          },
          Tree: {
            colorBgContainer: '#EDF1F5',
          },
          Pagination: {
            itemBg: 'transparent',
          },
        },
      }}
    >
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
};
